import * as angular from 'angular';
import { LanguageService } from './../services/languge.service';

function filterFunction(languageService: LanguageService ) {
    return function formatCurrency(total: number, lang: number): string {
        if (!total) {
            total = 0;
        }
        const langSettings = languageService.getLangSettingsOrDefault(lang);
        /* format  trunc part*/
        const truncNumber = `${Math.trunc(total)}`;
        const groups = truncNumber.match(new RegExp('.{1,3}(?=(.{3})*$)', 'g'));
        const truncResult = groups.reduce((prev, curr) => prev + langSettings.groupSeparator + curr);
        /* format  fractional part*/
        const fracNumber = (total % 1).toFixed(2).substring(2);

        return `${langSettings.currencySign}${langSettings.currencySeparator}${truncResult}${langSettings.decimalSeparator}${fracNumber}`;
    };
}

angular.module('app.common').filter('formatCurrency', filterFunction);

filterFunction.$inject = ['languageService'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/format-currency.filter.ts